export type ExponeaEventName = (typeof EXPONEA_EVENTS)[keyof typeof EXPONEA_EVENTS];

export const EXPONEA_EVENTS = {
	INSTALLMENT_APPLICATION_CUSTOMER_INTERESTED: 'installment_application-customer-interested',
	CREDIT_SEEKERS_MAXI_CLICKED: 'CreditSeekers-MAXI_button_clicked',
	CREDIT_SEEKERS_INSTALLMENT_NONPURPOSE_CLICKED:
		'CreditSeekers-INSTALLMENT_NONPURPOSE_button_clicked',
	CREDIT_SEEKERS_INSTALLMENT_CLICKED: 'CreditSeekers-INSTALLMENT_button_clicked',
} as const;

export const identify = (user: { id: string } | null | undefined): void => {
	if (typeof window !== 'undefined' && window.exponea && user !== null && user !== undefined) {
		window.exponea.identify({
			registered: user.id,
		});
	}
};

export const anonymize = (): void => {
	if (typeof window !== 'undefined' && window.exponea) {
		window.exponea.anonymize();
	}
};

export const track = (event: ExponeaEventName, properties?: Record<string, unknown>): void => {
	if (typeof window !== 'undefined' && window.exponea) {
		window.exponea.track(event, properties);
	}
};
